import React, { FC } from 'react';

export interface AccessibleDescriptionProps {
  /** The text that will be read by the screen reader */
  SRText: string;
  /** Allows the component to get additional styles. */
  className?: string;
  /** HTML id for AccessibleDescription Component. */
  id?: string;
}

const AccessibleDescription: FC<AccessibleDescriptionProps> = ({
  SRText,
  className,
  id='accessible-description'
}) => (
  <p
    className={className}
    css={{
      display: 'none'
    }}
    id={id}
  >
    {SRText}
  </p>
);

export { AccessibleDescription };
export default AccessibleDescription;
